import { Grid } from '@mui/material';
import {
  WsColors,
  WsNoTimeLineData,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';
const NoTimeLineDataPreview = ({
  title = 'No activity log',
  subtitle = 'Try appliying some other filter',
  height = 650,
}: {
  title?: string;
  subtitle?: string;
  height?: number;
}) => {
  return (
    <Grid
      container
      rowSpacing={1}
      px={2}
      py={2.2}
      sx={{
        backgroundColor: WsColors.White,
        height: height,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        mt: 0.5,
      }}
    >
      <Grid
        item
        height={170}
        width={170}
        display="flex"
        alignItems="center"
        justifyContent="center"
        bgcolor={WsColors.TheBlues50}
        borderRadius="50%"
      >
        <WsNoTimeLineData />
      </Grid>
      <Grid item>
        <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
          {title}
        </WsTypography>
      </Grid>
      <Grid item>
        <WsTypography color={WsTypoColors.SECONDARY} variant={WsTypoVariants.SUB_TITLE}>
          {subtitle}
        </WsTypography>
      </Grid>
    </Grid>
  );
};

export default NoTimeLineDataPreview;
